module.exports = __webpack_public_path__ + "static/img/results_bg_stars.af2b33c3.svg";